module.exports = __webpack_public_path__ + "img/44948573fe383e65117c8404f06b44d2.8094f642.jpg";